import React, { useEffect, useState } from "react";
import { ViewEnquiry as getEnquiryDetails } from "../../../redux/services/EnquriesService/enquries.Services";
import { errorToast } from "../../../Utils/toast";

function ViewEnquiry({ data }) {
  const [enquiryData, setEnquiryData] = useState(null);
  const [loading, setLoading] = useState(true);

  const formatDateTime = (date) => {
    if (!date) return "-";
    return new Date(date)
      .toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
      .replace(/\//g, "-")
      .replace(",", "");
  };

  useEffect(() => {
    const fetchEnquiryDetails = async () => {
      try {
        setLoading(true);
        const response = await getEnquiryDetails({
          id: data?.id,
        });
        if (response?.success) {
          setEnquiryData(response?.data);
        } else {
          errorToast(response?.message || "Failed to fetch enquiry details");
        }
      } catch (error) {
        console.error("View Enquiry Error:", error);
        errorToast(
          error?.response?.data?.message || "Something went wrong"
        );
      } finally {
        setLoading(false);
      }
    };

    if (data?.id) {
      fetchEnquiryDetails();
    } 
  }, [data?.id]);

//   if (loading) {
//     return (
//       <div className="card-body text-center">
//         <p>Loading enquiry details...</p>
//       </div>
//     );
//   }


  

  return (
    <div className="card-body">
      <div className="row">

        <div className="col-md-6 mb-3">
          <strong>Name</strong>
          <p>{enquiryData?.name || "-"}</p>
        </div>

        <div className="col-md-6 mb-3">
          <strong>Email</strong>
          <p>{enquiryData?.email || "-"}</p>
        </div>

        <div className="col-md-6 mb-3">
          <strong>Mobile</strong>
          <p>{enquiryData?.mobile || "-"}</p>
        </div>

        <div className="col-md-6 mb-3">
          <strong>Status</strong>
          <p>
            <span
              className={`badge ${
                enquiryData?.status === 1
                  ? "bg-success"
                  : "bg-danger"
              }`}
            >
              {enquiryData?.status === 1 ? "Active" : "Inactive"}
            </span>
          </p>
        </div>

        <div className="col-md-12 mb-3">
          <strong>Message</strong>
          <p>{enquiryData?.message || "-"}</p>
        </div>

        <div className="col-md-6 mb-3">
          <label className="form-label">Created At</label>
          <input
            type="text"
            className="form-control"
            disabled
            value={
              enquiryData?.created_at
                ? formatDateTime(enquiryData.created_at)
                : "-"
            }
            readOnly
          />
        </div>

        <div className="col-md-6 mb-3">
          <label className="form-label">Updated At</label>
          <input
            type="text"
            className="form-control"
            disabled
            value={
              enquiryData?.updated_at
                ? formatDateTime(enquiryData.updated_at)
                : "-"
            }
            readOnly
          />
        </div>

      </div>
    </div>
  );
}

export default ViewEnquiry;